import { Controller } from "@hotwired/stimulus"

// Restaurar estado antes de que Turbo intercambie el body (evita flash).
// Se registra a nivel de módulo para ejecutarse una sola vez.
document.addEventListener("turbo:before-render", (event) => {
  if (window.innerWidth >= 768 && localStorage.getItem("sr-menu-pinned") === "1") {
    event.detail.newBody.classList.add("cat__menu-left--visible");
  }
});

// Reemplaza menu-left.cleanui-custom.js (antes jQuery + jScrollPane)
// Animaciones de submenú via CSS max-height transition (sin slideToggle)
export default class extends Controller {
  connect() {
    this._restorePinnedState();
    this._bindEvents();
  }

  disconnect() {
    this._unbindEvents();
  }

  // ---------------------------------------------------------------------------
  // Estado persistido
  // ---------------------------------------------------------------------------
  _restorePinnedState() {
    if (window.innerWidth >= 768 && localStorage.getItem("sr-menu-pinned") === "1") {
      document.body.classList.add("cat__menu-left--visible");
    }
  }

  // ---------------------------------------------------------------------------
  // Binding / unbinding
  // ---------------------------------------------------------------------------
  _bindEvents() {
    this._onSubmenuClick  = this._handleSubmenuClick.bind(this);
    this._onToggleClick   = this._handleToggleClick.bind(this);
    this._onBackdropClick = this._handleBackdropClick.bind(this);
    this._onResize        = this._handleResize.bind(this);

    document.addEventListener("click", this._onSubmenuClick);
    document.addEventListener("click", this._onToggleClick);
    document.addEventListener("click", this._onBackdropClick);
    window.addEventListener("resize", this._onResize);
  }

  _unbindEvents() {
    document.removeEventListener("click", this._onSubmenuClick);
    document.removeEventListener("click", this._onToggleClick);
    document.removeEventListener("click", this._onBackdropClick);
    window.removeEventListener("resize", this._onResize);
  }

  // ---------------------------------------------------------------------------
  // Handlers
  // ---------------------------------------------------------------------------
  _handleSubmenuClick(event) {
    const link = event.target.closest(".cat__menu-left__submenu > a");
    if (!link) return;

    if (
      document.body.classList.contains("cat__config--vertical") ||
      window.innerWidth < 768
    ) {
      event.preventDefault();
      const parent = link.parentElement;
      const isToggled = parent.classList.contains("cat__menu-left__submenu--toggled");

      // Cerrar otros submenús del mismo nivel si no es anidado
      if (!isToggled && !parent.parentElement.closest(".cat__menu-left__submenu")) {
        document
          .querySelectorAll(".cat__menu-left__submenu--toggled")
          .forEach((el) => el.classList.remove("cat__menu-left__submenu--toggled"));
      }

      parent.classList.toggle("cat__menu-left__submenu--toggled");
    }
  }

  _handleToggleClick(event) {
    if (!event.target.closest(".cat__menu-left__action--menu-toggle")) return;

    if (window.innerWidth < 768) {
      document.body.classList.toggle("cat__menu-left--visible--mobile");
    } else {
      document.body.classList.toggle("cat__menu-left--visible");
      localStorage.setItem(
        "sr-menu-pinned",
        document.body.classList.contains("cat__menu-left--visible") ? "1" : "0"
      );
    }
  }

  _handleBackdropClick(event) {
    if (!event.target.closest(".cat__menu-left__action--backdrop-toggle")) return;
    document.body.classList.remove("cat__menu-left--visible--mobile");
  }

  _handleResize() {
    if (
      document.body.classList.contains("cat__config--horizontal") ||
      window.innerWidth > 768
    ) {
      document
        .querySelectorAll(".cat__menu-left__submenu--toggled")
        .forEach((el) => el.classList.remove("cat__menu-left__submenu--toggled"));
    }
  }
}
